export const contactNumber = '1-855-696-1257';
//# sourceMappingURL=customerCareNumber.js.map